import getDefaultReminder from 'owa-calendar-forms-common/lib/utils/getDefaultReminder';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import initializeCalendarEvent from 'owa-calendar-forms-common/lib/utils/initializeCalendarEvent';
import { now } from 'owa-datetime';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';

/**
 * Initializes a new CalendarEvent based on current time
 */
export default function initializeNewCalendarEventWithAttendees(
    requiredAttendees: AttendeeType[]
): CalendarEvent {
    let event = {
        Start: getDefaultStart(now()),
        ReminderMinutesBeforeStart: getDefaultReminder(false),
    } as CalendarEvent;

    event.RequiredAttendees = requiredAttendees;

    return initializeCalendarEvent(event);
}
